import React, { useContext, useState, useEffect } from 'react';
import { COUNTDOWN } from '../../../brands/default/content/components/header';
import { getCountDown } from '../../../helpers/timer';
import ThemeContext from '../../../providers/ThemeProvider';

const CountDown = () => {
  const theme = useContext(ThemeContext);
  const [timeToPrint, setTimeToPrint] = useState(
    COUNTDOWN.initialCountDownTime,
  );

  useEffect(() => {
    setTimeToPrint(getCountDown());
    const interval = setInterval(() => {
      setTimeToPrint(getCountDown());
    }, 1_000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="nav-bar">
      <div
        className="countdownBanner"
        data-testid="countdownBanner"
        id="pricesRefreshTimer"
      >
        <span className="countdownText">{COUNTDOWN.title}: </span>
        <span
          className="countdownDigits"
          style={{ opacity: timeToPrint === COUNTDOWN.title ? 0 : 1 }}
        >
          {timeToPrint}
        </span>
      </div>
      <style jsx>{`
        .nav-bar {
          -moz-box-shadow: inset 0 6px 6px -6px rgba(68, 68, 68, 0.6);
          -webkit-box-shadow: inset 0 6px 6px -6px rgba(68, 68, 68, 0.6);
          background-color: ${theme.colors.navbackground};
          border-bottom: 2px solid #d2d2d2;
          box-shadow: inset 0 6px 6px -6px rgba(68, 68, 68, 0.6);
          display: block;
          font-weight: 600;
          padding: 5px;
          position: relative;
          position: relative;
          text-align: center;
          width: 100%;
        }
        .countdownText {
          color: ${theme.colors.countdowntext};
        }
        .countdownDigits {
          color: ${theme.colors.countdownnumbers};
        }

        @media only screen and (min-width: ${theme.breakpoints.mdUp}) {
          .countdownBanner {
            font-size: 1.4em;
          }
        }
      `}</style>
    </div>
  );
};

export default CountDown;
